import * as type from "../../types/API/logisticDetails";
import { IAction } from "../userMetadataReducer";

const initialState = {
  data: null,
  loading: false,
  error: null,
};

export const getLogisticDetailsReducer = (state = initialState, action: IAction) => {
  switch (action.type) {
    case type.GET_LOGISTIC_DETAILS:
      return {
        ...state,
        loading: true,
      };
    case type.GET_LOGISTIC_DETAILS_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload.responseData,
      };
    case type.GET_LOGISTIC_DETAILS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    default:
      return state;
  }
};

export const addLogisticDetailsReducer = (state = initialState, action: IAction) => {
  switch (action.type) {
    case type.ADD_LOGISTIC_DETAILS:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case type.ADD_LOGISTIC_DETAILS_SUCCESS:
      return {
        error: null,
        loading: false,
        data: action.payload.responseData,
      };
    case type.ADD_LOGISTIC_DETAILS_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    default:
      return state;
  }
};

export const editLogisticDetailsReducer = (state = initialState, action: IAction) => {
  switch (action.type) {
    case type.EDIT_LOGISTIC_DETAILS:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case type.EDIT_LOGISTIC_DETAILS_SUCCESS:
      return {
        error: null,
        loading: false,
        data: action.payload.responseData,
      };
    case type.EDIT_LOGISTIC_DETAILS_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    default:
      return state;
  }
};

export const deleteLogisticDetailsReducer = (state = initialState, action: IAction) => {
  switch (action.type) {
    case type.DELETE_LOGISTIC_DETAILS:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case type.DELETE_LOGISTIC_DETAILS_SUCCESS:
      return {
        error: null,
        loading: false,
        data: action.payload.responseData,
      };
    case type.DELETE_LOGISTIC_DETAILS_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    default:
      return state;
  }
};
 